import Axios from "axios";
import { toast } from "react-toastify";

export const logoutUser = () => {
  // Clear user session (localStorage, cookies, etc.)
  localStorage.removeItem("authToken");
  toast.warning("Please try to login again");
  // Redirect to login page
  setTimeout(() => {
    window.location.replace("/login");
  }, 3000);
};

export const fetcher = async (url) => {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No token");
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const res = await Axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.log(error);

    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
};
export const fileFetcher = async (url) => {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No token");

  try {
    const res = await Axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob", // Request the response as a Blob
    });

    return URL.createObjectURL(res.data); // Create a URL from the Blob
  } catch (error) {
    console.log(error);

    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
};

export const customFetcher = async (url, token) => {
  // if (!token) throw new Error("No token");
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const res = await Axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.log(error);

    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
};

export const noAuthfetcher = async (url) => {
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const res = await Axios.get(apiUrl);
    return res.data;
  } catch (error) {
    console.log(error);

    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
};

export const swrConfig = {
  fetcher,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  revalidateOnMount: true,
  refreshWhenOffline: true,
  shouldRetryOnError: false,
  onError: (error) => {},
};

export async function sendPostRequest(url, { arg }) {
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const response = await Axios.post(apiUrl, arg);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendPostRequestAuth(url, { arg }) {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No token");
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const response = await Axios.post(apiUrl, arg, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
}

export async function sendPutRequestAuth(url, { arg }) {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No token");
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const response = await Axios.put(apiUrl, arg, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
}

export async function sendDeleteRequestAuth(url) {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No token");
  const apiUrl = process.env.REACT_APP_BASE_URL + url;
  try {
    const response = await Axios.delete(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 403) {
      logoutUser();
    }
    throw error;
  }
}
